var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEsqueceuSuaSenha(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39.314,
    height: 50.224,
    viewBox: "0 0 39.314 50.224",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "esqueceu-sua-senha",
    transform: "translate(-76 -26.053)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_115",
    "data-name": "Caminho 115",
    d: "M110.4,233.948H80.914A4.929,4.929,0,0,0,76,238.862v17.691a4.929,4.929,0,0,0,4.914,4.914H110.4a4.929,4.929,0,0,0,4.914-4.914V238.862A4.929,4.929,0,0,0,110.4,233.948Zm-22.592,14.79a1.081,1.081,0,0,1-1.081,1.872l-1.783-1.03v2.06a1.081,1.081,0,0,1-2.162,0v-2.06L81,250.61a1.081,1.081,0,0,1-1.081-1.872l1.784-1.03-1.784-1.03A1.081,1.081,0,1,1,81,244.807l1.783,1.03v-2.059a1.081,1.081,0,0,1,2.162,0v2.06l1.783-1.03a1.081,1.081,0,1,1,1.081,1.872l-1.784,1.03Zm11.794,0a1.081,1.081,0,0,1-1.081,1.872l-1.783-1.03v2.06a1.081,1.081,0,0,1-2.162,0v-2.06l-1.783,1.03a1.081,1.081,0,0,1-1.081-1.872l1.784-1.03-1.784-1.03a1.081,1.081,0,1,1,1.081-1.872l1.783,1.03v-2.059a1.081,1.081,0,0,1,2.162,0v2.06l1.783-1.03a1.081,1.081,0,1,1,1.081,1.872l-1.784,1.03Zm11.794,0a1.081,1.081,0,0,1-1.081,1.872l-1.783-1.03v2.06a1.081,1.081,0,0,1-2.162,0v-2.06l-1.783,1.03a1.081,1.081,0,0,1-1.081-1.872l1.784-1.03-1.784-1.03a1.081,1.081,0,1,1,1.081-1.872l1.783,1.03v-2.059a1.081,1.081,0,0,1,2.162,0v2.06l1.783-1.03a1.081,1.081,0,1,1,1.081,1.872l-1.784,1.03Z",
    transform: "translate(0 -185.192)",
    fill: "#005a9e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_116",
    "data-name": "Caminho 116",
    d: "M140.265,38.928a10.714,10.714,0,0,1,21.427,0v7.666h2.162V38.928a12.875,12.875,0,0,0-25.75,0v7.666h2.162Z",
    transform: "translate(-55.321 0)",
    fill: "#005a9e"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEsqueceuSuaSenha);
export default __webpack_public_path__ + "static/media/esqueceu-sua-senha.05b9d76502e12a734ffa641aba854010.svg";
export { ForwardRef as ReactComponent };